import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { centerAbsolute } from '@/styles/helpers';

export const HeaderTitleBox = styled(Typography.Header).attrs({
  $variant: '3',
})`
  ${centerAbsolute()}
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
